import account from './services/account';
import registration from './services/registration';
import ageGroup from './services/ageGroup';
import auth from './services/auth';
import email from './services/email';
import alerts from './services/alerts';
import signups from './services/signups';
import secrets from './services/secrets';
import sms from './services/sms';
import accountAge from './services/accountAge';
import session from './services/session';
import location from './services/location';
import pinpoint from './services/pinpoint';
import apiGateway from './services/apiGateway';

const dataService = ({
    modules: {
        account,
        registration,
        ageGroup,
        auth,
        email,
        alerts,
        signups,
        secrets,
        sms,
        accountAge,
        session,
        location,
        pinpoint,
        apiGateway
    },  
})

export default dataService;